import React from 'react';
import PhotoUpload from '../common/PhotoUpload';

const CheckinForm = ({ formData, sites = [], onChange, photos = [], onPhotosChange, photosMandatory = false, photosDisabled = false }) => {
  return (
    <div className="checkin-form">
      <h2 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600 }}>Check-In Details</h2>

      <div className="form-group">
        <label htmlFor="checkinFrom">Check-in from *</label>
        <div style={{ display: 'flex', gap: '12px', marginBottom: '8px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="radio"
              name="checkinFrom"
              value="person"
              checked={formData.checkinFrom === 'person'}
              onChange={onChange}
            />
            <span style={{ fontSize: '13px' }}>Person</span>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="radio"
              name="checkinFrom"
              value="site"
              checked={formData.checkinFrom === 'site'}
              onChange={onChange}
            />
            <span style={{ fontSize: '13px' }}>Site-Location</span>
          </label>
        </div>
      </div>

      {formData.checkinFrom === 'site' && (
        <div className="form-group">
          <label htmlFor="checkinSite">Select Site-Location</label>
          <select
            id="checkinSite"
            name="site"
            value={formData.site}
            onChange={onChange}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '2px solid #e2e8f0',
              borderRadius: '6px',
              fontSize: '13px'
            }}
          >
            <option value="">Select Site</option>
            {sites.map(site => (
              <option key={site.id || site._id} value={site.id || site._id}>
                {site.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="form-group">
        <label htmlFor="returnDate">Return Date *</label>
        <input
          id="returnDate"
          type="date"
          name="returnDate"
          value={formData.returnDate}
          onChange={onChange}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="condition">Condition *</label>
        <select
          id="condition"
          name="condition"
          value={formData.condition || 'good'}
          onChange={onChange}
          required
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '2px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '13px'
          }}
        >
          <option value="good">Good</option>
          <option value="damaged">Damaged</option>
          <option value="repair_needed">Repair Needed</option>
        </select>
      </div>

      <div className="form-group">
        <PhotoUpload
          photos={photos}
          onPhotosChange={onPhotosChange}
          mandatory={photosMandatory}
          label="Checkin Photos"
          disabled={photosDisabled}
        />
      </div>
    </div>
  );
};

export default CheckinForm;
